import type { AssessmentQuestion } from '@entities/assessment'

import imgQuestion2 from '../../../../ui/images/questions/math/grade-k9/question-2.png'
import imgQuestion4 from '../../../../ui/images/questions/math/grade-k9/question-4.png'
import imgQuestion5 from '../../../../ui/images/questions/math/grade-k9/question-5.png'
import imgQuestion6 from '../../../../ui/images/questions/math/grade-k9/question-6.png'
import imgQuestion8 from '../../../../ui/images/questions/math/grade-k9/question-8.png'
import imgQuestion10 from '../../../../ui/images/questions/math/grade-k9/question-10.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k9_1',
    title: 'Simplify the following equation: 3x + 4x² - 7x + x²',
    topic: 'Algebra I',
    answers: [
      { name: 'grade_k9_1_a', text: '6x - 2x²' },
      { name: 'grade_k9_1_b', text: '5x² - 4x', correct: true },
      { name: 'grade_k9_1_c', text: '4x² - x' },
      { name: 'grade_k9_1_d', text: '7x - 6x²' },
    ],
  },
  {
    name: 'grade_k9_2',
    title: 'A teacher recorded the most common types of pets amongst students in their class and produced the following bar chart. How many disciplines in the class have a cat as a pet?',
    topic: 'Statistics',
    image: imgQuestion2,
    answers: [
      { name: 'grade_k9_2_a', text: '10' },
      { name: 'grade_k9_2_b', text: '6', correct: true },
      { name: 'grade_k9_2_c', text: '4' },
      { name: 'grade_k9_2_d', text: '3' },
    ],
  },
  {
    name: 'grade_k9_3',
    title: 'Expand and simplify the following equation: 2(x + 5) + 3(x + 6)',
    topic: 'Algebra I',
    answers: [
      { name: 'grade_k9_3_a', text: '5x + 28', correct: true },
      { name: 'grade_k9_3_b', text: '7x + 19' },
      { name: 'grade_k9_3_c', text: '6x + 21' },
      { name: 'grade_k9_3_d', text: '4x + 24' },
    ],
  },
  {
    name: 'grade_k9_4',
    title: 'Work out the length of the side x in the below right-angled triangle:',
    topic: 'Trigonometry',
    image: imgQuestion4,
    answers: [
      { name: 'grade_k9_4_a', text: '12cm' },
      { name: 'grade_k9_4_b', text: '9cm' },
      { name: 'grade_k9_4_c', text: '8cm', correct: true },
      { name: 'grade_k9_4_d', text: '11cm' },
    ],
  },
  {
    name: 'grade_k9_5',
    title: 'Work out the volume of the cylinder below:',
    topic: 'Volume in Geometry',
    image: imgQuestion5,
    answers: [
      { name: 'grade_k9_5_a', text: '2463.01 cm³', correct: true },
      { name: 'grade_k9_5_b', text: '1934 cm³' },
      { name: 'grade_k9_5_c', text: '3289 cm³' },
      { name: 'grade_k9_5_d', text: '2895 cm³' },
    ],
  },
  {
    name: 'grade_k9_6',
    title: 'Find the equation of the polynomial graphed below:',
    topic: 'Pre-Calculus',
    image: imgQuestion6,
    answers: [
      { name: 'grade_k9_6_a', text: 'y = (x − 2)2(x + 3)(x + 4)' },
      { name: 'grade_k9_6_b', text: 'y = (x + 2)2(x − 3)(x − 4)' },
      { name: 'grade_k9_6_c', text: 'y = (x + 2)(x − 3)(x − 4)' },
      { name: 'grade_k9_6_d', text: 'y = (x − 2)(x + 3)(x + 4)', correct: true },
    ],
  },
  {
    name: 'grade_k9_7',
    title: 'Your parents are renting a car at a cost of $25 per day, plus an additional gas cost of $0.15 per mile. Using x to represent the miles driven, which expression helps us calculate the cost of driving for a day?',
    topic: 'Algebra I',
    answers: [
      { name: 'grade_k9_7_a', text: '25x + 0.15' },
      { name: 'grade_k9_7_b', text: '0.15x' },
      { name: 'grade_k9_7_c', text: '25 + 0.15x', correct: true },
      { name: 'grade_k9_7_d', text: '0.15 + 25x' },
    ],
  },
  {
    name: 'grade_k9_8',
    title: 'The length of the rectangle is x + 4, and the width is x − 2. What is the expression for its area?',
    topic: 'Geometry',
    image: imgQuestion8,
    answers: [
      { name: 'grade_k9_8_a', text: 'x² + 2x + 4' },
      { name: 'grade_k9_8_b', text: 'x² + 2x + 8' },
      { name: 'grade_k9_8_c', text: 'x² + 2x − 4' },
      { name: 'grade_k9_8_d', text: 'x² + 2x − 8', correct: true },
    ],
  },
  {
    name: 'grade_k9_9',
    title: 'If 5 pieces of candy cost $2.00, how much would 8 pieces of candy cost at the same rate?',
    topic: 'Ratios and Proportions',
    answers: [
      { name: 'grade_k9_9_a', text: '$3.20', correct: true },
      { name: 'grade_k9_9_b', text: '$3.80' },
      { name: 'grade_k9_9_c', text: '$4.00' },
      { name: 'grade_k9_9_d', text: '$4.50' },
    ],
  },
  {
    name: 'grade_k9_10',
    title: 'What type of function does the data in this graph represent?',
    topic: 'Graphing Equations and Functions',
    image: imgQuestion10,
    answers: [
      { name: 'grade_k9_10_a', text: 'Linear' },
      { name: 'grade_k9_10_b', text: 'Exponential', correct: true },
      { name: 'grade_k9_10_c', text: 'Quadratic' },
      { name: 'grade_k9_10_d', text: 'Cubic' },
    ],
  },
]
